import React from "react";
import { styled } from "styled-components";

// Adding `1` to the top parameters fixes some weird offset scrolling issues, without this there is one pixel of wiggle-room where the sticky bar actually scrolls out of view for a pixel. Adding the extra one pixel fixes this issue
const StyledDiv = styled.div<{ $top?: number; $bottom?: number }>`
  position: -webkit-sticky;
  position: sticky;
  ${({ $top, $bottom }) => ($top || !$bottom ? `top: ${($top || 0) + 1}px;` : "")}
  ${({ $bottom }) => ($bottom ? `bottom: ${$bottom}px;` : "")}
`;

type StickyProps = {
  top?: number;
  bottom?: number;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

const Sticky = ({ top, bottom, style, children }: StickyProps) => {
  return (
    <StyledDiv $top={top} $bottom={bottom} style={style}>
      {children}
    </StyledDiv>
  );
};

export default Sticky;
